module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-12-2f0e91960a5dd8e34d82e3151f4d5f83.svg";